<template>
  <BaseTableWrapper>
    <template #top-buttons>
      <div class="float-right mb-1">
        <router-link tag="button" :to="{ name: 'EXSBPaymentsMadeCreate' }" class="btn btn-sm btn-primary">{{ $t('buttons.create') }}</router-link>
      </div>
    </template>
    <template #filtering>
      <div class="text-right">
        <b-button v-if="filterStatus" variant="danger" class="btn-sm" v-b-tooltip.hover :title="$t('buttons.clearFilters')" @click="clearFilters"><i class="fa fa-sync"></i><span>{{$t('global.filtersAreSet')}}</span></b-button>
        <b-button class="btn-sm ml-2" v-b-tooltip.hover :title="$t('buttons.search')"  v-b-toggle.userdata_search_collapse variant="primary"><i class="fa fa-filter"></i></b-button>
      </div>
      <div>
        <b-collapse id="userdata_search_collapse" class="mt-2">
          <PaymentMadeFiltering
            @getPage="getPage($event)"
            ref="paymentMadeFiltering"></PaymentMadeFiltering>
        </b-collapse>
      </div>
    </template>
    <template #body>
      <div v-if="isLoading">
        <Loader></Loader>
      </div>
      <div v-else-if="!isLoading && items.length < 1">
        {{ $t('views.excmcyclictask.list.noTasks') }}
      </div>
      <div v-else>
        <table class="table table-sm table-responsive-md table-striped table-hover">
          <thead>
          <tr>
            <th>{{ $t('views.exsbpaymentsmade.list.paymentDate') }}</th>
            <th>{{ $t('views.excmnotificationmessage.form.description') }}</th>
            <th>{{ $t('views.exsbpaymentsmade.list.idBankPackage') }}</th>
            <th>{{ $t('views.exsbpaymentsmade.list.agreement') }}</th>
            <th>{{ $t('views.exsbpaymentsmade.list.invoice') }}</th>
            <th>{{ $t('views.exsbpaymentsmade.list.value') }}</th>
            <th style="width: 10%;"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" :key="item['@id']">
            <td>{{ $moment(item.paymentDate).format('YYYY-MM-DD') }}</td>
            <td>
              <span v-if="item.idBankPayment">{{ item.idBankPayment.description }}</span>
              <span v-else>{{ item.description }}</span>
            </td>
            <td>
              <div v-if="item.idBankPayment" class="btn-group">
                <router-link tag="button" class="btn btn-link fa fa-search fa-lg" :to="{ name: 'EXSBBankPackagesShow', params: { id: item.idBankPayment.idBankPackages } }"></router-link>
              </div>
              <i v-else class="fa fa-times-circle" style="color: #dc3545"></i>
            </td>
            <td>
              <router-link v-if="item.idAgreement" :to="{ name: 'EXABAgreementShow', params: { id: item.idAgreement['@id'] } }">
                {{ item.idAgreement.number }} {{ item.idAgreement.idClient.fullName + ' ' + item.idAgreement.idClient.firmname1 }}
              </router-link>
            </td>
            <td>
              <router-link v-if="item.idEXSBInvoice" :to="{ name: 'EXSBInvoiceShow', params: { id: item.idEXSBInvoice['@id'] } }">
                {{ item.idEXSBInvoice.number }}
                <span v-if="item.idEXSBInvoice.idUserData"><br>{{item.idEXSBInvoice.idUserData.firmname1}}</span>
              </router-link>
            </td>
            <td>{{ item.value }} {{$t('currency')}}</td>
            <td>
              <div class="btn-group">
                <router-link tag="button" class="btn btn-link fa fa-search fa-lg" :to="{ name: 'EXSBPaymentsMadeShow', params: { id: item['@id'] }}"></router-link>
                <router-link v-if="item.idBankPayment" tag="button" class="btn btn-link fa fa-edit fa-lg" :to="{ name: 'EXSBPaymentsMadeUpdate', params: { id: item['@id'] }}"></router-link>
                <b-button @click="deleteSingle(item['@id'])" v-else class="btn btn-link fa fa-trash fa-lg"></b-button>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-if="view">
        <Pagination
          :view="view"
          :totalItems="totalItems"
          @getPage="getPage($event)"
          @getPageNumber="setCurrentPage($event.page)"
        ></Pagination>
      </div>
    </template>
  </BaseTableWrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import Pagination from '@/components/Dashboard/Layout/Pagination'
import Loader from '@/components/Dashboard/Layout/Loader'
import { checkPagePermission } from '@/utils/checkRoles'
import remove from '@/utils/remove'
import PaymentMadeFiltering from '@/components/Dashboard/Views/BusinessBundle/exsbpaymentsmade/components/PaymentMadeFiltering.vue'
import addParamsToQuery from '@/utils/addParamsToQuery'

export default {
  name: 'List',
  components: {
    PaymentMadeFiltering,
    BaseTableWrapper,
    Pagination,
    Loader
  },
  data () {
    return {
      searchParams: this.$store.state.filters.paymentsMadeFilter
    }
  },
  computed: {
    ...mapGetters({
      error: 'exsbpaymentsmade/list/error',
      items: 'exsbpaymentsmade/list/items',
      isLoading: 'exsbpaymentsmade/list/isLoading',
      view: 'exsbpaymentsmade/list/view',
      totalItems: 'exsbpaymentsmade/list/totalItems'
    }),
    filterStatus () {
      return JSON.stringify(this.$store.state.filters.paymentsMadeFilter) !== JSON.stringify(this.$store.state.filters.paymentsMadeFilterReference)
    }
  },
  beforeCreate () {
    checkPagePermission('finances', 'EXSBPaymentsMadeList')
    if (Object.keys(this.$store.state.filters.paymentsMadeFilter).length === 0) {
      this.$store.state.filters.paymentsMadeFilter = JSON.parse(JSON.stringify(this.$store.state.filters.paymentsMadeFilterReference))
    }
  },
  created () {
    let params = Object.assign({ '_page': this.$store.state.filters.paymentsMadeFilterCurrentPage }, this.searchParams)
    if (params.bankPayment === 1) {
      params['idBankPayment[exists]'] = true
    } else if (params.bankPayment === 2) {
      params['idBankPayment[exists]'] = false
    }
    params.bankPayment = undefined
    if (params.invoice === 1) {
      params['idEXSBInvoice[exists]'] = true
    } else if (params.invoice === 2) {
      params['idEXSBInvoice[exists]'] = false
    }
    params.invoice = undefined
    let url = addParamsToQuery('e_x_s_b_payments_mades', params)
    this.getPage(url)
  },
  methods: {
    ...mapActions({
      getPage: 'exsbpaymentsmade/list/getItems'
    }),
    setCurrentPage (page) {
      this.$store.state.filters.paymentsMadeFilterCurrentPage = page
    },
    clearFilters () {
      if (this.$refs.paymentMadeFiltering) {
        this.$refs.paymentMadeFiltering.clearFilters()
      }
    },
    deleteSingle (id) {
      remove(id, () => {
        this.getPage(this.view)
      })
    }
  }
}
</script>

<style scoped>

</style>
